import { Component, computed, Inject, Input } from '@angular/core';

import { FormComponent } from '../form.component/form.component';
import { MasterService } from '../../core/services/master.service';
import { ModalService } from '../../core/services/modal.service';

@Component({
  selector: 'app-modal',
  imports: [FormComponent],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent {

  readonly s_modal = Inject(ModalService).modal;

  constructor(private _svc_master:MasterService, private _svc_modal:ModalService) { 
    this.s_modal = this._svc_modal.modal;
  }

  modal_close() {
    this._svc_master.trg_modal('modal-close');
  }

}
